import { create } from "zustand";

// Who the Senior Care actions are for. null = the logged-in user (self).
// mode: 'self' | 'guardian' | null
export const useCareRecipientStore = create((set) => ({
  recipient: null,
  mode: null,
  setRecipient: (r) => set({ recipient: r }),
  setMode: (m) => set({ mode: m }),
  clear: () => set({ recipient: null, mode: null }),
}));
